module.exports = __webpack_public_path__ + "static/controlsYes-dc934d0c40a04f02f599fc2d1517319d.png";